/**
 * One optional answer at cancel or at trial end (Paul, Oct 28 2026). Capture only: the server
 * stores it next to the existing path and never changes billing. Never throws.
 */
import { CLOUD_API_URL } from '../config/serverConfig';
import { getToken } from './apiAuthStorage';
import { getConnectorVersion } from '../utils/connectorVersion';

export const LEAVE_CHOICES = [
  'playback_problems', 'my_gear_not_supported', 'missing_feature', 'price', 'use_another_app', 'not_listening_enough', 'other',
] as const;
export type LeaveMoment = 'cancel' | 'trial_expiry';

export async function sendLeaveReason(moment: LeaveMoment, choice: string, freeText: string): Promise<boolean> {
  const token = getToken();
  if (!token) return false;
  try {
    const res = await fetch(`${CLOUD_API_URL}/api/valet/leave-reason`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      credentials: 'omit',
      body: JSON.stringify({
        moment,
        choice,
        free_text: freeText.trim().slice(0, 1000),
        connector_version: getConnectorVersion() || null,
        platform: (window as any).__MAESTRO_DESKTOP_OS__ || null,
      }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
